import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

function PrimerAssemblyTabOptions(): JSX.Element {
  return (
    <ul className="nav navbar-nav">
      <li className="pull-right">
        <div>
          <button type="button" className="button button--mini button--secondary js-clone-into-wizard">
            Re-open [?]
          </button>
        </div>
        <div className="js-finalize-group">
          <button
            type="button"
            className="button button--mini button--primary js-save"
            {...getTestProps({component: 'PrimerAssemblyTabOptions', element: 'finalizeButton'})}
          >
            Finalize [?]
          </button>
        </div>
      </li>
      <li>
        <div className="buttonGroup">
          <button type="button" className="button button--mini button--tertiaryGray js-primer-tab-settings">
            Settings
          </button>
          <button type="button" className="button button--mini button--tertiaryGray js-print">
            <span className="glyphicon glyphicon-print" />
          </button>
        </div>
      </li>
      <li>
        <div className="buttonGroup">
          <button type="button" className="button button--mini button--tertiaryGray js-copy-primers">
            Copy Primers
          </button>
          <div className="buttonGroup js-export-group">
            <a className="button button--mini button--secondary">Export CSV</a>
          </div>
        </div>
      </li>
    </ul>
  );
}

export default makeDeprecatedJadeStyleTemplate(PrimerAssemblyTabOptions);
